// Responsável por montar as mensagens padrões do sistema
import * as msg from './mensagens'

export const MSG_ERRO = 'MSG_ERRO'
export const MSG_ALERTA = 'MSG_ALERTA'
export const MSG_SUCESSO = 'MSG_SUCESSO'

export default {
  gerar(tipo, arrMensagem, item = []) {
    try {
      if (arrMensagem.length <= 0) {
        return { tipo: MSG_ERRO, mensagens: [msg.ERRO_INTERNO] }
      }

      let arrRetorno = []
      if (typeof arrMensagem === 'string') {
        arrRetorno.push(arrMensagem)
      } else {
        arrRetorno = arrRetorno.concat(arrMensagem)
      }

      return { tipo, mensagens: arrRetorno, documento: item }
    } catch {
      return { tipo: MSG_ERRO, mensagens: [msg.ERRO_INTERNO] }
    }
  },
  retornaSomenteMensagens(arrMensagem) {
    try {
      const arrErros = []
      arrMensagem.forEach(item => {
        if (item.msg) {
          arrErros.push(item.msg)
        }
      })

      return arrErros
    } catch {
      return []
    }
  },
}
